<template>
    <div class="success--text" style="font-size: 11px; font-weight: 600">
        <v-icon x-small color="success">mdi-check</v-icon>
        {{ text }}
    </div>
</template>

<script>
export default {
    name: 'withdrawal-status',

    props: {
        text: {
            type: String,
            required: true
        }
    }
}
</script>
